<template>
  <div class="wrap">
    <div class="head clearfix yp-topbar">
      <ul>
        <div v-model="check" class="fl" v-show="isA" @click="choose()">
          {{isChooseAll ? '取消全选' : '全选'}}
        </div>
        <div class="fr" v-show="isA" @click="cancel">
          取消
        </div>
        <div class="tittle" v-show="!len">回收站</div>
        <div class="tittle" v-show="len">已选择{{len}}文件</div>
        <li @click="checkMobile" v-show="!isA" class="check-mobile" id="check-recycle"></li>
        <router-link to="/more/setinfo" slot="left" v-show="!isA">
          <li class="back"></li>
        </router-link>
      </ul>
    </div>
    <div v-if="list.length===0" class="jpg" v-cloak>
      <div>
        <img src="../../assets/images/null.png" alt="">
        <p>您的回收站为空噢～</p>
      </div>
    </div>
    <ul class="ulBox" ref="ulBox" v-else
        infinite-scroll-distance="0" infinite-scroll-immediate-check="false"
        v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" id="mainlist">
      <li v-for="(item,index) in list" class="Rlist">
        <div class="Rlistin">
          <em class="check" :class="{'checked': item.isB, 'nochecked': !item.isB}" @click="checked(item)" ref="mycheck"
              v-show="isA"
              :fileId="item.id"></em>
          <!--<i v-bind:class="[sliceType(item.fileName, item.isDir)]"></i>-->
          <span :class="styleObject(item.fileName,item.isDir)"
                v-if="sliceType(item.fileName,item.isDir)!=='package'">
               <i :class="classObject(item.fileName,item.isDir)" class="iconfont"
                  style="font-size: .6rem"></i>
            </span>
          <svg class="icon" aria-hidden="true" v-else id="package">
            <use xlink:href="#icon-package"></use>
          </svg>
          <div class="middle">
            <div class="left_info">
              <h3>{{item.fileName | sName(15)}}</h3>
              <span>{{formaTime(item.gmtModified)}}</span>
            </div>
            <div class="right_length">
              <span>{{bytesToSize(item.length)}}</span>
              <span>{{item.remainDay}}天</span>
            </div>
          </div>
        </div>
        <div @click="toggleUp(index)" id="more" :class="{'more':up===index}"></div>
        <div class="div" v-if="select===index">
          <ul class="listBox clearfix">
            <li>
              <!--<img src="../../assets/images/recover_gray.png" alt="">-->
              <i class="iconfont icon-huanyuan" style="font-size: .48rem;
    display: block;color: #999999"></i>
              <p @click="two_recover($event)" :id="item.id">还原</p>
            </li>
            <li>
              <!--<img src="../../assets/images/detele_gray.png" alt="">-->
              <i class="iconfont icon-lajitong" style="font-size: .48rem;
    display: block;color: #999999"></i>
              <p @click="two_delete(item)" :id="item.id">删除</p>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <mt-tabbar v-show="!isA">
      <mt-tab-item id="一键清空" class="active">
        <button @click="one_delete" v-show="!isA" class="button">一键清空</button>
      </mt-tab-item>
    </mt-tabbar>
    <mt-tabbar v-show="isA" v-bind:class="{'selected': isA, 'selected-t': opacity}">
      <mt-tab-item id="还原">
        <!--<img slot="icon" src="../../assets/images/recover_t.png" @click="recoverList('还原')">-->
        <i class="iconfont icon-huanyuan" style="font-size: .48rem;
    display: block;" @click="recoverList('还原')"></i>
        <span @click="recoverList('还原')">还原</span>
      </mt-tab-item>
      <mt-tab-item id="删除">
        <i class="iconfont icon-lajitong" style="font-size: .48rem;
    display: block;" @click="deleteList('删除')"></i>
        <span @click="deleteList('删除')">删除</span>
      </mt-tab-item>
    </mt-tabbar>
  </div>
</template>
<script type="text/ecmascript-6">
  import apis from '../../apis/index'
  import cloudApi from '../../apis/cloudStorageApi'
  import { formaTime, sliceType, bytesToSize } from '../../assets/js/tools'
  import { MessageBox, Toast } from 'mint-ui'

  export default {
    data () {
      return {
        isA: false,
        isB: false,
        isChooseAll: false,
        check: '全选',
        opacity: true,
        up: '',
        list: [],
        ids: [],
        len: 0,
        delArr: [],
        data: {
          page: 0,
          size: 20
        },
        select: '',
        isShow: false,
        noSelect: true,
        id: 'id',
        targetfileId: 'targetfileId',
        page: 0,
        size: 20,
        flag: false,
        totalElements: 0,
        totalPages: 0
      }
    },
    components: {
      sliceType,
      MessageBox,
      Toast
    },
    created () {
      this._showList()
    },
    methods: {
      classObject (val, val2) {
        let type = this.sliceType(val, val2)
        return 'icon-' + type
      },
      styleObject (val, val2) {
        let type = this.sliceType(val, val2)
        if (type === 'excel') {
          return 'excel'
        } else if (type === 'pdf') {
          return 'pdf'
        } else if (type === 'word') {
          return 'word'
        } else if (type === 'txt') {
          return 'txt'
        } else if (type === 'pic') {
          return 'pic'
        } else if (type === 'muisc') {
          return 'muisc'
        } else if (type === 'dir') {
          return 'dir'
        } else if (type === 'html') {
          return 'html'
        } else {
          return 'weizhi'
        }
      },
      checkMobile () {
        if (this.list.length !== 0) {
          this.flag ? this.flag = false : this.flag = true
          this.isA ? this.isA = false : this.isA = true
          this.select = ''
        }
      },
      choose () {
        if (this.isChooseAll) {
          this.cancelcheckAll()
        } else {
          this.checkAll()
        }
      },
      checkAll () {
        this.isChooseAll = true
        this.len = true
        this.len = this.list.length
        if (this.list.length > 0) {
          this.list.forEach((row) => {
            row.isB = true
          })
        }
        this.opacity = false
      },
      cancelcheckAll () {
        this.isChooseAll = false
        this.len = false
        if (this.list.length > 0) {
          this.list.forEach((row) => {
            row.isB = false
          })
        }
        this.opacity = true
      },
      checked (item) {
        if (item.isB === undefined) {
          this.$set(item, 'isB', true)
          this.opacity = false
          this.len++
          return
        }
        if (item.isB) {
          item.isB = false
          this.len--
          if (this.len === 0) {
            this.opacity = true
          } else {
            this.opacity = false
          }
        } else {
          item.isB = true
          this.opacity = false
          this.len++
        }
      },
      toggleUp (index) {
        console.log(index)
        if (this.select === index) {
          this.select = ''
          this.up = ''
        } else {
          this.select = index
          this.up = index
        }
      },
      cancel () {
        this.isA ? this.isA = false : this.isA = true
        var _this = this
        this.opacity = true
        _this.isChooseAll = false
        _this.cancelcheckAll()
      },
      one_delete () {
        var _this = this
        if (_this.list.length !== 0) {
          MessageBox.confirm('删除', {
            message: '<div class="title">删除</div><div class="info">' +
            '<div>确定要删除吗？</div>' +
            '<div>删除后将无法恢复</div>' +
            '</div>',
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(function () {
            apis.request(cloudApi.clearRemovedFile, {}).then(function () {
              Toast({
                message: '删除成功',
                iconClass: 'icon-success'
              })
              _this._showList()
            }).catch(function (error) {
              Toast({
                message: error.response.data.message,
                iconClass: 'icon-error'
              })
            })
          })
        }
      },
      _showList () {
        var _this = this
        apis.request(cloudApi.delList, _this.data).then(function (response) {
          var data = response.data.content
          _this.list = []
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              _this.targetfileId = data[i].pid
              _this.list.push(data[i])
              _this.id = data[i].id
            }
            _this.totalElements = response.data.totalElements
            _this.totalPages = response.data.totalPages
          } else {
            _this.list = []
          }
          return false
        })
      },
      two_delete (item) {
        let _this = this
        if (item) {
          _this.ids.push(item.id)
          MessageBox.confirm('删除', {
            message: '<div class="title">删除</div><div class="info">' +
            '<div>确定要删除吗？</div>' +
            '<div>删除后将无法恢复</div>' +
            '</div>',
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            apis.request(cloudApi.permRemove, {fileIds: _this.ids.join(',')}).then(function () {
              Toast({
                message: '删除成功',
                iconClass: 'icon-success'
              })
              _this._showList()
              _this.restore()
            }).catch(function (error) {
              Toast({
                message: error.response.data.message,
                iconClass: 'icon-error'
              })
            })
          })
        }
      },
      two_recover (event) {
        var _this = this
        var id = event.target.id
        MessageBox.confirm('恢复', {
          message: '<div class="title">恢复</div><div class="info">确定要恢复吗？</div>',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(function () {
          apis.request(cloudApi.recover, {fileIds: id, targetFileId: _this.targetfileId}).then(function () {
            _this._showList()
            Toast({
              message: '恢复成功',
              iconClass: 'icon-success'
            })
            _this.restore()
          }).catch(function (error) {
            Toast({
              message: error.response.data.message,
              iconClass: 'icon-error'
            })
          })
        })
      },
      recoverList () {
        this.list.forEach((value) => {
          if (value.isB) {
            this.ids.push(value.id)
            this.box()
          }
        })
      },
      deleteList () {
        this.list.forEach((value) => {
          if (value.isB) {
            this.ids.push(value.id)
            this.box1()
          }
        })
      },
      box () {
        MessageBox.confirm('恢复', {
          message: '<div class="title">恢复</div><div class="info">确定要恢复吗？</div>',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          apis.request(cloudApi.recover, {fileIds: this.ids.join(',')}).then(() => {
            this._showList()
            Toast({
              message: '恢复成功',
              iconClass: 'icon-success'
            })
            this.restore()
          }).catch((error) => {
            Toast({
              message: error.response.data.message,
              iconClass: 'icon-error'
            })
          })
        })
      },
      box1 () {
        MessageBox.confirm('删除', {
          message: '<div class="title">删除</div><div class="info">确定要删除吗？</div>',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          apis.request(cloudApi.permRemove, {fileIds: this.ids.join(',')}).then(() => {
            this._showList()
            Toast({
              message: '删除成功',
              iconClass: 'icon-success'
            })
            this.restore()
          }).catch((error) => {
            Toast({
              message: error.response.data.message,
              iconClass: 'icon-error'
            })
          })
        })
      },
      restore () {
        this.opacity = true
        this.select = ''
        this.isChooseAll = false
        this.isA = false
        this.isB = false
        this.fileId = ''
        this.up = ''
        this.len = 0
        this.flag = false
        this.page = 0
        this.size = 20
        this.info = {
          page: 0,
          size: 20
        }
      },
//      scroll: function () {
//        let sw = true
//        let _this = this
//        let ulBox = _this.$refs.ulBox
//        if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
//          if (sw === true) {
//            sw = false
//            _this.page++
//            apis.request(cloudApi.delList, {page: _this.page, size: _this.size}).then(function (res) {
//              let data = res.data.content
//              if (data.length > 0) {
//                for (let i = 0; i < data.length; i++) {
//                  _this.list.push(data[i])
//                }
//              }
//              return false
//            })
//            sw = true
//          }
//        }
//      },
      loadMore () {
        this.loading = true
        let content = document.getElementById('mainlist')
        if (content.scrollHeight - content.scrollTop - content.offsetHeight < 10) {
          if (this.totalElements > this.list.length) {
            setTimeout(() => {
              let _this = this
              if (_this.page < _this.totalPages) {
                _this.page++
              }
              apis.request(cloudApi.delList, {page: _this.page, size: _this.size}).then(function (res) {
                let list0 = []
                let data = res.data.content
                if (data.length > 0) {
                  for (var i = 0; i < data.length; i++) {
                    list0.push(data[i])
                    data[i].gmtCreate = formaTime(data[i].gmtCreate)
                  }
                  if (_this.list && list0) {
                    _this.list = _this.list.concat(list0)
                  }
                }
              })
              this.loading = false
            }, 250)
          }
        }
      },
      sliceType (val, num) {
        if (val !== '' || undefined) {
          var point = val.lastIndexOf('.')
          var type = val.substring(point + 1).toLowerCase()
          if (num === 1) {
            return 'dir'
          }
          if (type === 'jpg' || type === 'gif' || type === 'JPG' || type === 'GIF' || type === 'png') {
            return 'pic'
          } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
            return 'video'
          } else if (num === 1) {
            return 'dir'
          } else if (type === 'txt') {
            return 'txt'
          } else if (type === 'pdf') {
            return 'pdf'
          } else if (type === 'doc' || type === 'docx') {
            return 'word'
          } else if (type === 'ppt' || type === 'pptx') {
            return 'ppt'
          } else if (type === 'xls' || type === 'xlsx') {
            return 'excel'
          } else if (type === 'html' || type === 'htm') {
            return 'html'
          } else if (type === 'wps' || type === 'wpt') {
            return 'wps'
          } else if (type === 'zip' || type === 'rar') {
            return 'package'
          } else {
            return 'default'
          }
        }
      },
      bytesToSize: function (bytes) {
        if (bytes === 0) return '0 B'
        if (bytes === '') return ''
        var k = 1024
        var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        var i = Math.floor(Math.log(bytes) / Math.log(k))
        return (bytes / Math.pow(k, i)).toPrecision(3) + sizes[i]
      },
      formaTime: (val) => {
        if (val !== '' || undefined || null) {
          return new Date(val).format('yyyy-MM-dd HH:mm')
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  [v-cloak] {
    display: none;
  }

  .iconfont {
    font-size: 0.62rem;
    vertical-align: middle;
  }

  html {
    overflow: scroll !important;
  }

  body {
    font-size: 0.16rem !important;
  }

  .wrap {
    padding-top: 1.28rem;
    height: 100%;
    padding-bottom: 1rem;
  }

  .head {
    position: fixed;
    top: 0;
    height: 1.28rem;
    width: 100%;
    padding-top: 0.32rem;
  }

  .head .tittle {
    position: absolute;
    color: #fff;
    left: 40%;
    font-size: .36rem;
    margin-top: .2rem;
  }

  .head ul {
    text-align: center;
    /*position: relative;*/
    overflow: hidden;
    padding: 0 .3rem;
  }

  .ulBox {
    overflow-y: scroll;
    height: 100%;
    background-color: #fff;
  }

  .fl {
    font-size: .28rem;
    line-height: 1rem;
    position: absolute;
    left: .3rem;
    color: #FFFFFF;
  }

  .fr {
    font-size: .28rem;
    line-height: 1rem;
    position: absolute;
    right: .3rem;
    color: #FFFFFF;
  }

  .middle {
    display: inline-block;
    vertical-align: middle;
    /*line-height: .4rem;*/
    /*margin-top: .2rem;*/
    margin-left: .2rem;
    padding-top: .1rem;
    width: 70%;
  }

  .left_info {

  }

  .left_info h3 {
    font-size: .28rem;
    color: #1D1F22;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .left_info span {
    font-size: .2rem;
    color: #9B9B9B;
    vertical-align: middle;
  }

  .right_length {
    /* float: right;*/
    position: absolute;
    right: .9rem;
    margin-left: .2rem;
    /*line-height: .5rem;*/
    font-size: .18rem;
    top: .35rem;
  }

  .right_length span:nth-of-type(1) {
    margin-right: .22rem;
    color: #9b9b9b;
  }

  #more {
    width: 0.2rem;
    height: 0.26rem;
    position: absolute;
    right: 0.2rem;
    top: 0.35rem;
    background: url("../../assets/images/down.png") center no-repeat;
    background-size: 0.18rem 0.12rem;
  }

  .more {
    background: url("../../assets/images/up.png") center no-repeat !important;
    background-size: 0.18rem 0.12rem !important;
  }

  .ulBox > li {
    position: relative;
    border-bottom: 1px solid #E5E5E5;
    text-align: left;
  }

  li img {
    float: left;
    width: 0.5rem;
    height: 0.5rem;
    display: inline-block;
  }

  .left {
    /*padding-left: .2rem;*/
    display: inline-block;
  }

  a {
    color: #42b983;
  }

  .check {
    width: 0.24rem;
    height: 0.24rem;
    border: 1px solid #979797;
    display: inline-block;
    border-radius: 50%;
    /*margin-bottom: 0.12rem;*/
    margin-right: 0.25rem;
  }

  .checked {
    background: url('../../assets/images/success_big.png') center no-repeat;
    background-size: 0.24rem 0.24rem;
    border: none;
  }

  .nochecked {
    border: 1px solid #979797;
  }

  /*无内容时的样子*/
  .jpg {
    position: relative;
    height: 100%;
  }

  .jpg > div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .jpg div p {
    font-size: 0.28rem;
    color: #41464c;
  }

  .div {
    height: .98rem;
    background: #f7f7fa
  }

  .div ul {
    overflow: hidden;
    padding: .1rem 0;
  }

  .div ul li {
    display: inline-block;
    width: 50%;
    text-align: center;
    float: left;
  }

  .div ul li img {
    float: initial;
    width: 0.35rem;
    height: 0.36rem;
  }

  .button {
    width: 100%;
    text-align: center;
    height: .75rem;
    background: #E4393C;
    color: #fff;
    border: 1px solid #E4393C;
    font-size: .36rem;
    border-radius: 8px;
  }

  .deteleBut ul {
    height: .9rem;
    width: 100%;
    text-align: center;
  }

  .deteleBut ul li {
    width: 40%;
    float: left;
  }

  .deteleBut ul li img {
    position: absolute;
  }

  .deteleBut ul li p {
    margin-top: .55rem;
    margin-left: .55rem;
  }

  .check-mobile {
    background: url("../../assets/images/check-mobile.png") center no-repeat;
    background-size: 0.36rem 0.36rem;
  }

  #check-recycle {
    width: 0.36rem;
    height: 0.36rem;
    float: right;
    margin-top: .25rem;
  }

  .mint-tabbar {
    height: 1rem;
    font-size: 0.2rem !important;
    background-color: #3f4b5e;
  }

  .mint-tab-item {
    padding: .1rem .2rem;
  }

  .mint-tab-item-icon img {
    width: 0.34rem;
    height: 0.36rem;
    margin: 0 auto;
  }

  .mint-tab-item-icon {
    height: 0 !important;
  }

  .back {
    width: .2rem;
    height: .3rem;
    /*margin-left: .3rem;*/
    background: url("../../assets/images/back.png") no-repeat;
    background-size: .2rem .3rem;
    display: inline-block;
    float: left;
    margin-top: .25rem;
  }
</style>
<style scoped lang="scss">
  .mint-tab-item-label {
    /*line-height: 0 !important;*/
    color: inherit;
  }

  .selected {
    background-color: #3f4b5f;
    color: #fff !important;
    font-size: 0.2rem;
  }

  .selected-t a {
    opacity: 0.3;
  }

  a {
    color: inherit !important;
  }

  .icon-success {
    background: url("../../assets/images/success_icon.png") center no-repeat;
    background-size: 0.98rem 0.7rem;
    margin: 0 auto;
    width: 0.98rem;
    height: 0.7rem;
  }

  .icon-error {
    background: url("../../assets/images/x.png") center no-repeat;
    margin: 0 auto;
    width: 0.98rem;
    height: 0.7rem;
  }

  .Rlist {
    .Rlistin {
      height: 0.99rem;
      padding-top: 0.14rem;
      padding-left: 0.3rem;
      width: 78%;
    }
  }

  #package {
    vertical-align: middle;
  }
</style>
<style>
  .mint-msgbox-message .info {
    color: #9b9b9b;
    font-size: .28rem;
    margin-top: .2rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/recycle/recycle.vue